import React, { useState } from "react";
import { DatePicker  } from "antd";

const SetACreditRemind = () => {
    const [startDate, setStartDate] = useState(new Date("2025-03-26"));

  return (
    <>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasSetACreditReminder"
        aria-labelledby="offcanvasSetACreditReminder"
        style={{ minWidth: "30%", maxWidth: "30%" }}
      >
        <div className="offcanvas-header bg-primary">
          <h4 id="offcanvasSetProposalReminder" className="text-white">
            Set A CreditNote Reminder
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="mb-3 col-12">
              <label>Date</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Set Reminder To</label>
              <select className="form-select">
                <option>A</option>
                <option>B</option>
              </select>
            </div>
            <div className="mb-3 mt-1 col-12">
                      <label>Description</label>
                      <textarea
                        className="form-control"
                        placeholder="Enter Description"
                      ></textarea>
                    </div>
            <div className="page-btn ">
              <button className="btn btn-primary page-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SetACreditRemind;
